import * as moment from 'moment-timezone'

export const DATE_FORMAT = 'MM/DD/YYYY'

export const dateStringToIso = (date: string, dateFormat: string = DATE_FORMAT) => {
    return moment.utc(date, dateFormat).toISOString()
}
